// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.config-group .text-error[data-v-003dd1f8] {\r\n  color: #fc4a40 !important;\r\n  padding: 0;\r\n  position: static;\r\n  border: none !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
